import { render, staticRenderFns } from "./PayoutStatusChipField.vue?vue&type=template&id=31038e6c"
import script from "./PayoutStatusChipField.vue?vue&type=script&lang=js"
export * from "./PayoutStatusChipField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports